import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap } from 'rxjs';

import { mapErrorToAction, mapToPayload } from 'ish-core/utils/operators';

import { DotCmsResourceService } from '../../services/dot-cms-resource/dot-cms-resource.service';
import { getDotCmsCommonRequestParams } from '../utils/dotcms-store-utils';

import {
  loadDotCmsContentlet,
  loadDotCmsContentletFail,
  loadDotCmsContentletSuccess,
} from './dotcms-contentlets.action';

@Injectable()
export class DotCmsContentletEffects {
  constructor(private actions$: Actions, private store: Store, private dotCmsResourceService: DotCmsResourceService) {}

  loadDotCmsContentlet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDotCmsContentlet),
      mapToPayload(),
      getDotCmsCommonRequestParams(this.store),
      mergeMap(([payload, hostId, language]) =>
        this.dotCmsResourceService
          .getContentByInodeOrIdentifier(payload.identifier, { hostId, language, depth: payload.depth })
          .pipe(
            map(contentlet => loadDotCmsContentletSuccess({ contentlet })),
            mapErrorToAction(loadDotCmsContentletFail)
          )
      )
    )
  );
}
